module.exports = __webpack_public_path__ + "img/view-schedule.e06b5b04.png";